import { DatePipe } from '@angular/common';
import { Component, Input, OnInit,EventEmitter,Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RequirementService } from '@services/requirement.service';
import { DeleteNoteComponent } from '../pop-up/delete-note/delete-note.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EditNoteComponent } from '../pop-up/edit-note/edit-note.component';
import { parseApiInstant } from '../util/parse-api-instant';

@Component({
    selector: 'app-notes',
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.scss'],
    standalone: false,
    providers: [DatePipe],
})
export class NotesComponent implements OnInit {
@Input() dataNote;
@Input() path;
@Input() isNote: boolean = false;
@Input() dataUser;
@Input() requirementid;
@Output() deleteNoteEmit = new EventEmitter<boolean>();
@Output() editNoteEmit = new EventEmitter<number>();
@Output() saveEditNoteEmit = new EventEmitter<boolean>();

getPath: string = 'trackvision/requirement/getnotebyid'
dataRequirement: null;

  constructor(
    private modalService: NgbModal,
    public _requirements: RequirementService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
  }

	/* Delete a Note*/
	deleteNote(id: number) {
		const modalRef = this.modalService.open(DeleteNoteComponent, {
			size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.idFile = id;
		modalRef.componentInstance.path = this.path;
		modalRef.componentInstance.title = 'Nota';
		modalRef.componentInstance.deleteFile.subscribe(deleteFile => {
			if (deleteFile) {
				setTimeout(() => this.deleteNoteEmit.emit(deleteFile), 1000);
			}
		});
	}





	formatDate(date: string | Date | null | undefined): string {
		const instant = parseApiInstant(date);
		if (!instant) return 'Sin Fecha';
		return (
			this.datePipe.transform(
				instant,
				'MMM d, y h:mm a',
				undefined,
				'en-US'
			) ?? ''
		);
	}


  getSafeHtml(note: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(note);
  }


  editNote(idNote) {
		let servicePath: string;

		const modalRef = this.modalService.open(EditNoteComponent, {
			scrollable: true, size: 'md', backdrop: 'static',
			keyboard: false
		});
      modalRef.componentInstance.requirementId = this.requirementid;
      modalRef.componentInstance.path = "trackvision/requirement/editnote";
      modalRef.componentInstance.getPath = this.getPath;
      modalRef.componentInstance.titelModal = "Editar Nota";
      modalRef.componentInstance.idnote = idNote;
      modalRef.componentInstance.edicion = 1;
      modalRef.componentInstance.servicePath="trackvision/requirement/editnote";
      modalRef.componentInstance.saveEditNoteEmit.subscribe(saveEditNoteEmit => {
        this.saveEditNoteEmit.emit(true);
      });
	}
}
